import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import Benvenuto from '../components/Benvenuto'
import { Card } from '../components/common'
import { DashboardPersonalizzabile } from '../components/DashboardPersonalizzabile'
import Sonar, { Radar } from '../components/Sonar'
import { dashboardPredefinita } from '../components/widget/modello'
import { t } from '../i18n/lingua'
import { toggle, type Quadro } from '../sonar'

/**
 * La home del portale: la dashboard personalizzabile (motore in
 * `DashboardPersonalizzabile`), con l'onboarding, il sonar e il radar sopra e
 * il collegamento al sinottico. Le aree della console non si ripetono qui: ci
 * sono già nel selettore delle aree in alto a sinistra (1/11/2026: «non serve,
 * c'è già il menu»).
 */
export default function Dashboard() {
  const navigate = useNavigate()
  const [quadro, setQuadro] = useState<Quadro>('nessuno')
  return (
    <DashboardPersonalizzabile
      kind="home"
      predefinita={dashboardPredefinita}
      azioni={(dash) => (
        <>
          <button type="button" className="secondary" onClick={() => setQuadro(toggle(quadro, 'sonar'))}>{t('Sonar')}</button>
          <button type="button" className="secondary" onClick={() => setQuadro(toggle(quadro, 'radar'))}>{t('Radar')}</button>
          <button type="button" className="secondary" onClick={() => navigate(`/sinottico${dash.id ? `?d=${dash.id}` : ''}`)}>{t('Sinottico')}</button>
        </>
      )}
      sopra={
        <>
          <Benvenuto />
          {quadro === 'sonar' && (
            <Card title={t('Sonar')}>
              <p style={{ marginTop: 0 }} className="text-muted">
                {t('Quello che la piattaforma ha sotto di sé, e ogni pesce è un CI. In verde ciò che ha riconosciuto e catalogato; in rosso, lampeggiante, ciò che non ha ancora riconosciuto — o che è comparso adesso.')}
              </p>
              <Sonar onClose={() => setQuadro('nessuno')} />
            </Card>
          )}
          {quadro === 'radar' && (
            <Card title={t('Radar')}>
              <p style={{ marginTop: 0 }} className="text-muted">
                {t("Lo stesso parco, a colpo d'occhio: un punto per CI, i rossi verso il centro. Nessuna scena da guardare — si legge e si chiude.")}
              </p>
              <Radar onClose={() => setQuadro('nessuno')} />
            </Card>
          )}
        </>
      }
    />
  )
}
